import { env } from './env';

export const paths = {
  home: {
    path: '/',
    getHref: () => '/',
  },
  homePage: {
    path: '/home',
    getHref: () => '/home',
  },
  plans: {
    path: '/plans',
    getHref: () => '/plans',
  },
  properties: {
    path: '/properties',
    getHref: () => '/properties',
  },
  propertiesRegister: {
    path: '/properties/register',
    getHref: () => '/properties/register',
  },
  property: {
    path: '/properties/:propertyId',
    getHref: (propertyId: string) => `/properties/${propertyId}`,
  },
  companies: {
    path: '/companies',
    getHref: () => '/companies',
  },
  reports: {
    path: '/reports',
    getHref: () => '/reports',
  },
  members: {
    path: '/members',
    getHref: () => '/members',
  },

  auth: {
    login: {
      path: '/login',
      getHref: (redirectTo?: string) => (redirectTo ? `/login?redirectTo=${redirectTo}` : '/login'),
    },
    logout: {
      path: '/logout',
      getHref: () => '/logout',
    },
    callback: {
      path: env.OIDC_CALLBACK_PATH,
      getHref: () => env.OIDC_CALLBACK_PATH,
    },
  },

  onboarding: {
    path: 'onboarding',
    getHref: () => '/o/onboarding',
  },

  error: {
    path: '/error',
    getHref: () => '/error',
  },
  notFound: {
    path: '/404',
    getHref: () => '/404',
  },
  notAuthorized: {
    path: '/403',
    getHref: () => '/403',
  },

  companyRegistration: {
    path: '/companies/register',
    getHref: () => '/companies/register',
  },
  supplierRegistration: {
    path: '/companies/register',
    getHref: () => '/companies/register',
  },
  companiesRegister: {
    path: '/companies/register',
    getHref: () => '/companies/register',
  },
  companiesRoutes: {
    suppliers: {
      path: '/companies/suppliers',
      getHref: () => '/companies/suppliers',
    },
    supplier: {
      path: '/companies/supplier/:supplierId',
      getHref: (supplierId: string) => `/companies/supplier/${supplierId}`,
    },
    customers: {
      path: '/companies/customers',
      getHref: () => '/companies/customers',
    },
    customer: {
      path: '/companies/customer/:customerId',
      getHref: (customerId: string) => `/companies/customer/${customerId}`,
    },
    constructionCompany: {
      path: '/companies/construction-company/:constructionCompanyId',
      getHref: (constructionCompanyId: string) =>
        `/companies/construction-company/${constructionCompanyId}`,
    },
    witnessCompany: {
      path: '/companies/witness-company/:witnessCompanyId',
      getHref: (witnessCompanyId: string) => `/companies/witness-company/${witnessCompanyId}`,
    },
  },

  org: {
    root: {
      path: '/o',
      getHref: () => '/o',
    },
    userProfile: {
      path: 'profile',
      getHref: () => '/o/profile',
    },
    companies: {
      path: 'companies',
      getHref: () => '/o/companies',
    },
    selectedOrg: {
      path: ':orgId',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    dashboard: {
      path: '',
      getHref: (orgId: string) => `/o/${orgId}`,
    },
    users: {
      path: 'users',
      getHref: (orgId: string) => `/o/${orgId}/users`,
    },
    user: {
      path: 'users/:userId',
      getHref: (orgId: string, userId: string) => `/o/${orgId}/users/${userId}`,
    },
    roles: {
      path: 'roles',
      getHref: (orgId: string) => `/o/${orgId}/roles`,
    },
    role: {
      path: 'roles/:roleId',
      getHref: (orgId: string, roleId: string) => `/o/${orgId}/roles/${roleId}`,
    },
    orgProfile: {
      path: 'org-profile',
      getHref: (orgId: string) => `/o/${orgId}/org-profile`,
    },
  },

  app: {
    root: {
      path: '',
      getHref: () => '/admin',
    },
    dashboard: {
      path: '',
      getHref: () => '/admin',
    },
    users: {
      path: 'users',
      getHref: () => '/admin/users',
    },
    orgs: {
      path: 'orgs',
      getHref: () => '/admin/orgs',
    },
    roles: {
      path: 'roles',
      getHref: () => '/admin/roles',
    },
    profile: {
      path: 'profile',
      getHref: () => '/admin/profile',
    },
    user: {
      path: 'user/:userId',
      getHref: (userId: string) => `/admin/user/${userId}`,
    },
    apps: {
      path: 'apps',
      getHref: () => '/admin/apps',
    },
    app: {
      path: 'apps/:appId',
      getHref: (appId: string) => `/admin/apps/${appId}`,
    },
  },
} as const;
